<app-hero [title]="'Über uns'" *ngIf="showHero"></app-hero>

<!-- About Section -->
<section id="about" class="about section">
  <div class="container">
    <div class="row position-relative">
      <div class="col-lg-7 about-img" data-aos="zoom-out" data-aos-delay="200">
        <img src="assets/img/image6.jpg" alt="Unser Team">
      </div>

      <div class="col-lg-7" data-aos="fade-up" data-aos-delay="100">
        <h2 class="inner-title">Über uns & unsere Vision</h2>
        <div class="our-story">
          <h3>Wer wir sind</h3>
          <p>Wir sind ein leidenschaftliches Team, das sich Innovation und Exzellenz verschrieben hat. Unsere Mission ist es, hochwertige Lösungen anzubieten, die das Leben unserer Kunden verbessern.</p>
          <ul>
            <li><i class="bi bi-graph-up"></i> <span>Bereitstellung hochwertiger Lösungen</span></li>
            <li><i class="bi bi-people"></i> <span>Aufbau einer starken Gemeinschaft</span></li>
            <li><i class="bi bi-lightbulb"></i> <span>Innovation für die Zukunft</span></li>
          </ul>
          <p>Wir glauben an kontinuierliche Verbesserung, Kundenzufriedenheit und die Schaffung eines nachhaltigen Einflusses in der Branche.</p>
          <div class="watch-video d-flex align-items-center position-relative">
            <i class="bi bi-play-circle"></i>
            <a href="assets/img/image6.jpg" class="glightbox stretched-link">Video ansehen</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section id="stats-counter" class="stats-counter section">
  <div class="container section-title" data-aos="fade-up">
    <h2>Ab Nach Deutschland</h2>
    <p>Wir unterstützen Sie zuverlässig mit Herz und Erfahrung.</p>
  </div>

  <div class="container" data-aos="fade-up" data-aos-delay="100">
    <div class="row gy-4">
      <div class="col-lg-3 col-md-6">
        <div class="stats-item d-flex flex-column align-items-center justify-content-center w-100 h-100">
          <i class="bi bi-hand-thumbs-up color-blue flex-shrink-0"></i>
          <div class="d-flex flex-column align-items-center justify-content-center my-2">
            <h3>Zuverlässig.</h3>
            <p>Wir sind engagiert und planen realistisch.</p>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="stats-item d-flex flex-column align-items-center justify-content-center w-100 h-100">
          <i class="bi bi-check-square color-orange flex-shrink-0"></i>
          <div class="d-flex flex-column align-items-center justify-content-center my-2">
            <h3>Ehrlich.</h3>
            <p>Wir arbeiten transparent und offen.</p>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="stats-item d-flex flex-column align-items-center justify-content-center w-100 h-100">
          <i class="bi bi-person color-green flex-shrink-0"></i>
          <div class="d-flex flex-column align-items-center justify-content-center my-2">
            <h3>Persönlich.</h3>
            <p>Wir sind nah an den Menschen – im Ausland ebenso wie vor Ort.</p>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6">
        <div class="stats-item d-flex flex-column align-items-center justify-content-center w-100 h-100">
          <i class="bi bi-heart color-pink flex-shrink-0"></i>
          <div class="d-flex flex-column align-items-center justify-content-center my-2">
            <h3>Herzlich.</h3>
            <p>Wir handeln stets freundlich und respektvoll.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Alt Services Section -->
<section id="alt-services" class="alt-services section">
  <div class="container">
    <div class="row justify-content-around gy-4">
      <div class="features-image col-lg-6" data-aos="fade-up" data-aos-delay="100">
        <img src="assets/img/services.jpg" alt="Unsere Dienstleistungen">
      </div>

      <div class="col-lg-5 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay="200">
        <h3>Warum uns wählen?</h3>
        <p>Wir bieten eine breite Palette von Dienstleistungen, die auf Ihre Bedürfnisse zugeschnitten sind und Ihre Erwartungen übertreffen.</p>

        <div class="icon-box d-flex position-relative" data-aos="fade-up" data-aos-delay="300">
          <i class="bi bi-shield-lock flex-shrink-0"></i>
          <div>
            <h4><a href="" class="stretched-link">Zuverlässig & sicher</a></h4>
            <p>Wir legen großen Wert auf Sicherheit und Zuverlässigkeit in all unseren Lösungen.</p>
          </div>
        </div>

        <div class="icon-box d-flex position-relative" data-aos="fade-up" data-aos-delay="400">
          <i class="bi bi-gear-fill flex-shrink-0"></i>
          <div>
            <h4><a href="" class="stretched-link">Innovative Lösungen</a></h4>
            <p>Unser Team arbeitet kontinuierlich an modernsten Lösungen, die auf Sie zugeschnitten sind.</p>
          </div>
        </div>

        <div class="icon-box d-flex position-relative" data-aos="fade-up" data-aos-delay="500">
          <i class="bi bi-graph-up-arrow flex-shrink-0"></i>
          <div>
            <h4><a href="" class="stretched-link">Bewährtes Wachstum</a></h4>
            <p>Wir helfen Unternehmen und Einzelpersonen, bemerkenswerte Erfolge zu erzielen.</p>
          </div>
        </div>

        <div class="icon-box d-flex position-relative" data-aos="fade-up" data-aos-delay="600">
          <i class="bi bi-chat-dots flex-shrink-0"></i>
          <div>
            <h4><a href="" class="stretched-link">24/7 Kundensupport</a></h4>
            <p>Unser Team steht Ihnen jederzeit und überall zur Verfügung.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Testimonials Section -->
<section id="testimonials" class="testimonials section">
  <!-- Section Title -->
  <div class="container section-title" data-aos="fade-up">
    <h2>Erfahrungsberichte</h2>
    <p>Erfahren Sie, was Fachkräfte in Deutschland über ihre Berufserfahrungen und Karrierechancen sagen.</p>
  </div><!-- End Section Title -->

  <div class="container" data-aos="fade-up" data-aos-delay="100">
    <div class="testimonial-slider">
      <div class="testimonial-slide" *ngFor="let testimonial of testimonials">
        <div class="testimonial-wrap">
          <div class="testimonial-item">
            <img [src]="testimonial.image" class="testimonial-img" alt="{{ testimonial.author }}">
            <h3>{{ testimonial.author }}</h3>
            <h4>{{ testimonial.position }}</h4>
            <div class="stars">
              <i class="bi bi-star-fill" *ngFor="let star of getStars(testimonial.rating)"></i>
            </div>
            <p>
              <i class="bi bi-quote quote-icon-left"></i>
              <span>{{ testimonial.content }}</span>
              <i class="bi bi-quote quote-icon-right"></i>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section><!-- /Testimonials Section -->